import React from 'react';
import { StyledAvatar } from './UserAvatar.styles';

interface UserAvatarProps {
  firstName?: string;
  lastName?: string;
  email?: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeMap = {
  sm: '32px',
  md: '40px', 
  lg: '48px'
};

const fontSizeMap = {
  sm: '12px',
  md: '14px',
  lg: '16px'
};

export const UserAvatar: React.FC<UserAvatarProps> = ({ 
  firstName = '', 
  lastName = '', 
  email = '',
  size = 'md',
  className 
}) => {
  const getInitials = (): string => {
    if (firstName && lastName) {
      return `${firstName.charAt(0)}${lastName.charAt(0)}`;
    }
    if (firstName) {
      return firstName.charAt(0);
    }
    if (email) {
      return email.charAt(0);
    }
    return 'U';
  };

  return (
    <StyledAvatar 
      $size={sizeMap[size]} 
      $fontSize={fontSizeMap[size]}
      className={className}
      title={`${firstName} ${lastName}`.trim() || email || 'User'}
    >
      {getInitials()}
    </StyledAvatar>
  );
};
